/**
 * Created by hanyong.zheng on 2018/12/26.
 */
import { addService, getServiceList, getServiceInfo } from '@/api/service'

const service = {
  state: {
    serviceList: []
  },
  mutations: {
    SET_SERVICELIST: (state, serviceList) => {
      state.serviceList.length = 0
      if (serviceList.length !== 0) {
        serviceList.map(function (item) {
          state.serviceList.push(item)
        })
      }
    }
  },
  actions: {
    AddService ({ commit }, object) {
      return new Promise((resolve, reject) => {
        addService(object).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetServiceList ({ commit }, userId) {
      return new Promise((resolve, reject) => {
        getServiceList(userId).then(response => {
          const data = response.data
          if (data.code === '0') {
            commit('SET_SERVICELIST', data.data)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetServiceInfo ({ commit }, serviceParams) {
      return new Promise((resolve, reject) => {
        getServiceInfo(serviceParams).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default service



// WEBPACK FOOTER //
// ./src/store/modules/service.js